import { ProductBadgeSize } from '@services/MarppleShop/features/ProductBadge/types';
import { Lang } from '../../../../../types/global';
import { ProductBadgeView } from '../../../../../services/MarppleShop/renderApp/components/cells/ProductBadge';

/**
 * js에서 타입에러가 추적이 안 되니까 말아두었어요
 */
export const createStudioMembershipBadge = (lang: Lang['lang']) => {
  return new ProductBadgeView(
    {
      type: 'Membership',
      options: {
        size: ProductBadgeSize.medium,
        lang,
        ratio: 'square',
        hide_label: true,
        baseTimestamp: Date.now()
      }
    },
  );
};
